export default __webpack_public_path__ + "static/media/paper_visual_vestibular_2013.7bc5e051.png";